module.exports = __webpack_public_path__ + "static/media/canada.a004850a.jpeg";